<!-- 模版展示 -->
<template>
  <div>
    <div class="model-img-view">
      <van-image width="100%" :src="dataSource.img"/>
    </div>
    <div class="model-title">{{dataSource.title}}</div>
    <!-- <div class="model-sub-text">展品一键制作宣传海报，快速分享！</div> -->
    <div class="model-sub-text">{{dataSource.title.slice(0, 2)}}一键制作宣传海报，快速分享！</div>

    <!-- <div class="model-sub-text-1">已有200人制作，20000人看到过</div> -->
    <div class="model-start-btn-view">
      <div class="model-start-btn" @click="start">开 始 制 作</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      dataSource: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    start() {
      window.I.$RangersEvent('poster_editBtn');
      this.$router.push({
        name: 'edit',
        query: {item: JSON.stringify(this.dataSource),theme: this.$route.query.theme}
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.$store.commit('setGoodsInfo', null)
    this.$store.commit('setPrjectData', null)
    this.dataSource = JSON.parse(this.$route.query.item);
    window.I.$RangersEvent('poster_templateProfile', {
        template_id: this.dataSource.id
    });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.model-img-view {
  padding: 10px 30px 10px 30px;
}
.model-img {
  margin: 0 auto;
}
.model-title {
  text-align: center;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.model-sub-text {
  text-align: center;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 8px;
}
.model-sub-text-1 {
  text-align: center;
  margin-top: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}
.model-start-btn-view {
  margin-top: 10px;
  padding: 10px 30px 30px 30px;
  text-align: center;
}
.model-start-btn {
  height: 44px;
  background: var(--bgcolor);
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
</style>